// function for to bind custom event to check current address
jQuery.fn.bindCustomEvent = function (eventType, callback) {
	return this.each(function () {
		$(this).bind(eventType, function (e) {
			var page = String(callback);
			var num = page.indexOf("(a)") - 9;
			page = String(page.substr(9, num));
			$("title")[0].innerHTML = "The Fast Lane";
			callback(e);
		});
	});
};

$(document).ready(function () {
	$("#a_myAdmin").click(function () {
		adminFunction();
	});

	$(".dropdown-menu-item:not(.hiddenDropDown)").show();

	adaptTabsStart();
	$(window).resize(adaptTabsStart);

	$(".header-link, .header-sub-link, .exitApp").on("click", closeDMSReports);

	if ($("#numMessages").val() > 0) {
		var combinedMsgs = "";
		$.each($("#messages"), function (k, v) {
			combinedMsgs += v.value.replace(/,/g, "<br><br>").replace(/[[\]]/g, "");
		});
		$("#warningMsg").html(combinedMsgs).dialog({
			resizable: false,
			draggable: false,
			dialogClass: "alert-dialog",
			buttons: {
				OK: function () {
					$.ajax({
						type: "POST",
						url: "im2?ajax=markUserMessages",
						dataType: "text",
						async: false,
						success: function (msg) {
						},
						error: function (XMLHttpRequest, textStatus, errorThrown) {
						}
					});
					$(this).dialog("close");
				}
			},
			closeOnEscape: true,
			title: "New Messages For User",
			modal: true
		});
	}

	$(".trainingVideo").off("click").on("click", playVideoMarketingMessage);

});

function playVideoMarketingMessage(e) {
	$('.videoPopup').popup({
		autozindex:true,
		scrolllock:true,
		blur:true,
		onclose: function(){$('#innerVideoContainer').remove();}//,
		//transition: 'all 0.3s'
	});

	let vid = e.target.dataset.vid;
	openPopUpById("videoViewer");
	provajax.load('#videoViewer', '#videoViewer', 'im2?to=playVideo&vid=' + vid);
}

function adaptTabsStart() {
// the '0' is part of a safety mechanism to prevent an infinite loop
	adaptTabs(0, "start");
	$("#mainNavTabs").css("opacity", 100);
}


// Will auto adjust navigation tabs recursively depending on available space
function adaptTabs(idx, path) {
	if (idx > 10) return false;
	var currentTab;
	if ($("#tabNavDropDown .dropdown-menu-item:not(.hiddenDropDown)").length > 0) {
		$("#tabNavDropDown:not(.navTab)").show().toggleClass("navTab");
		$(".navTab.lastNavTab").toggleClass("lastNavTab");
	} else {
		$("#tabNavDropDown.navTab").hide().toggleClass("navTab");
		$(".navTab:last:not(.lastNavTab)").toggleClass("lastNavTab");
	}
	if ($("#mainNavTabs").height() > 60 && $("#mainNavTabs .navTab").length > 1) {
		currentTab = $("#mainNavTabs .navTab:not(.active):not(#tabNavDropDown):last");
		$("#" + currentTab.attr("data-reference-obj")).show().toggleClass("hiddenDropDown");
		currentTab.hide().toggleClass("navTab").toggleClass("hiddenTab");
		adaptTabs(idx + 1, "shrink");
	} else if ($("#mainNavTabs .hiddenTab").length > 0
			&& ($("#mainNavTabs").width() + getTabWidth($("#mainNavTabs .hiddenTab:first-of-type"))) < $("#tabNavContainer").width()
			&& path != "shrink") {
		currentTab = $("#mainNavTabs .hiddenTab:first");
		$("#" + currentTab.attr("data-reference-obj")).hide().toggleClass("hiddenDropDown");
		currentTab.show().toggleClass("navTab").toggleClass("hiddenTab");
		adaptTabs(idx + 1, "expand");
	}
}


function getTabWidth($obj) {
	if (!$obj.width()) return 0;
	return $obj.width() + parseInt($obj.css("padding-left").replace("px", ""), 10) + parseInt($obj.css("padding-right").replace("px", ""), 10) + parseInt($obj.css("border-left-width").replace("px", ""), 10) + parseInt($obj.css("border-right-width").replace("px", ""), 10);
}


function adminFunction() {
	$(location).attr("href", "im2?to=mainAdminPage");
}


function logoutApp() {
	deleteAllCookies();
	$(location).attr("href", "im2?to=logout");
}


function deleteAllCookies() {
	var cookies = document.cookie.split(";");

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf("=");
		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	}
}


function myQueue(to) {
	processNavMyQueue(to);
}


function navMyQueue(to) {
	processNavMyQueue(to);
}


function processNavMyQueue(to) {
// $("#dealDetailId") Contained in bodyHeader-private.jsp
	let dealDetailId = $("#dealDetailId").val() || "0";
	Promise.resolve(dealDetailId)
		.then(res => {
			if (res === "0" || res === 0 || res === "") {
				$(location).attr("href", "im2?to=" + to);
				return Promise.resolve();
			}
			return axios.get("im2?ajax=getUnsavedNewScenarioChanges&_=" + Date.now(), { responseType: "text", headers: dealModule.publicNoCacheHeaders })
				.then(res => confirmSaveNewScenario(res, $("#active-typ-cd").val(), String(res.data), $("#UnsavedChanges").val()))
				.then(res => axios.post("im2?ajax=closeDeal", Qs.stringify({ dealId: dealDetailId }), { responseType: "json" }))
				.then(res => $(location).attr("href", "im2?to=" + to));
		})
		.catch(err => {
			// A "Cancel Clicked" is acting like a cancel/short-circuit.
			if (err.message != "Cancel Clicked") {
				dealModule.errorPopup("Error", err.message);
				$(location).attr("href", "im2?to=" + to);
			}
		});
}

function confirmSaveNewScenario(res, typCd, unsavedNewScenarioChanges, unsavedChanges) {
	return new Promise((resolve, reject) => {
		if (unsavedNewScenarioChanges !== "1" && unsavedChanges !== "1") {
			resolve(res);
		} else {
			$("<div id='confirmation-popup-unsaved-new-scenario-changes'></div>").html('There are pending changes to the deal. Would you like to save these changes? Selecting "Yes" will route you back to the Structure tab. Selecting "No" will close the application and changes will be lost.').dialog({
				title: "Confirm",
				resizable: false,
				draggable: false,
				dialogClass: "alert-dialog",
				buttons: {
					Yes: function () {
						$(this).dialog("close");
						// From dealdeal.js
						// eslint-disable-next-line no-undef
						goFromCurrentTab("scenariosApplication", {}, null, null);
						$(".SecondaryNav a").removeClass("active");
						$(".SecondaryNav .Structure").addClass("active");
						reject(new Error("Cancel Clicked"));
					},
					No: function () {
						$(this).dialog("close");
						resolve(res);
					}
				},
				closeOnEscape: true,
				modal: true
			});
		}
	});
}

function closeDMSReports() {
	if (typeof closeDMSReportPrimaryApplicant !== "undefined") {
		closeDMSReportPrimaryApplicant.close();
	}
	if (typeof closeDMSReportCoApplicant !== "undefined") {
		closeDMSReportCoApplicant.close();
	}
}
